import {
    Injectable,
} from '@angular/core';

import {
    DomSanitizer,
} from '@angular/platform-browser';

import {
    MatIconRegistry,
} from '@angular/material/icon';


const ASSETS_FOLDER = 'assets/admins/';

@Injectable({
    providedIn: 'root',
})
export class AdminsAssets {

    constructor(
        iconRegistry: MatIconRegistry,
        sanitizer: DomSanitizer,
    ) {
        iconRegistry.addSvgIconInNamespace('admins', 'empty', sanitizer.bypassSecurityTrustResourceUrl(ASSETS_FOLDER + 'empty-box.svg'));
        iconRegistry.addSvgIconInNamespace('roles', 'empty', sanitizer.bypassSecurityTrustResourceUrl(ASSETS_FOLDER + 'empty-box.svg'));
    }

}
